import { LightningElement, api } from "lwc";

export type Variant = "info" | "error" | "warning" | "offline" | "preview";

export default class extends LightningElement {
  @api variant: Variant = "info";
  @api cookieKey: string | null = null;

  private isVisible = true;

  connectedCallback() {
    let cookie = this.getCookieValue();
    if (cookie) this.isVisible = false;
  }

  private get isDismissible() {
    return this.cookieKey !== null;
  }

  private handleRequestClose() {
    this.createCookie();
    this.isVisible = false;
  }

  private createCookie() {
    if (this.cookieKey !== null) {
      let date, expires;
      date = new Date();
      date.setTime(date.getTime() + 360 * 24 * 60 * 60 * 1000);
      expires = date.toUTCString();
      document.cookie = `${this.cookieKey}=true; expires=${expires}; path=/`;
    }
  }

  private getCookieValue() {
    if (this.cookieKey !== null) {
      const cookieString = "; " + document.cookie;
      const parts = cookieString.split(`; ${this.cookieKey}=`);
      if (parts.length === 2) {
        return parts.pop()!.split(";").shift();
      }
    }
    return null;
  }
}
